import { axiosGet, axiosPost } from '../../../../react_axios/Axios';
import {
    headers,
    getPhotographyAndVideographyMasterListUrl,
    insertUpdatePhotographyAndVideographyMasterUrl,
    deletePhotographyAndVideographyMasterUrl,
    GET_PHOTOGRAPHY_AND_VIDEOGRAPHY_MASTER_LIST,
    INSERT_UPDATE_PHOTOGRAPHY_AND_VIDEOGRAPHY_MASTER,
    DELETE_PHOTOGRAPHY_AND_VIDEOGRAPHY_MASTER,
} from '../../../../utils/constants';

export const getPhotographyAndVideographyMasterList_action = () => async (dispatch) => {
    try {
        const params = {
            UserID:       JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
        };
        const res = await axiosGet(getPhotographyAndVideographyMasterListUrl, params, headers);
        dispatch({ type: GET_PHOTOGRAPHY_AND_VIDEOGRAPHY_MASTER_LIST, payload: res });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

export const insertUpdatePhotographyAndVideographyMaster_action = (formData) => async (dispatch) => {
    try {
        const params = {
            UserID:       JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ...formData,
        };
        const res = await axiosPost(insertUpdatePhotographyAndVideographyMasterUrl, params, headers);
        dispatch({ type: INSERT_UPDATE_PHOTOGRAPHY_AND_VIDEOGRAPHY_MASTER, payload: res });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};

export const deletePhotographyAndVideographyMaster_action = (PhotographyAndVideographyID) => async (dispatch) => {
    try {
        const params = {
            UserID:       JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            PhotographyAndVideographyID,
        };
        const res = await axiosGet(deletePhotographyAndVideographyMasterUrl, params, headers);
        dispatch({ type: DELETE_PHOTOGRAPHY_AND_VIDEOGRAPHY_MASTER, payload: res });
        return Promise.resolve(res);
    } catch (error) {
        return Promise.reject(error);
    }
};
